const SECTION_COLORS = [
  { heading: "text-indigo-700", dot: "bg-indigo-500", bullet: "bg-indigo-300", badge: "bg-indigo-100 text-indigo-700" },
  { heading: "text-sky-700", dot: "bg-sky-500", bullet: "bg-sky-300", badge: "bg-sky-100 text-sky-700" },
  { heading: "text-emerald-700", dot: "bg-emerald-500", bullet: "bg-emerald-300", badge: "bg-emerald-100 text-emerald-700" },
  { heading: "text-amber-700", dot: "bg-amber-500", bullet: "bg-amber-300", badge: "bg-amber-100 text-amber-700" },
  { heading: "text-violet-700", dot: "bg-violet-500", bullet: "bg-violet-300", badge: "bg-violet-100 text-violet-700" },
  { heading: "text-rose-700", dot: "bg-rose-500", bullet: "bg-rose-300", badge: "bg-rose-100 text-rose-700" },
];

function renderInline(text) {
  return text.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
    part.startsWith("**") && part.endsWith("**") ? (
      <strong key={i} className="font-semibold text-slate-900">{part.slice(2, -2)}</strong>
    ) : (
      part
    )
  );
}

export function Markdown({ text, className = "" }) {
  const blocks = [];
  let list = null;
  let section = -1;
  const flush = () => { if (list) { blocks.push(list); list = null; } };

  (text || "").split("\n").forEach((line, idx) => {
    const t = line.trim();
    if (!t) { flush(); return; }
    if (t.startsWith("### ")) {
      flush();
      section = (section + 1) % SECTION_COLORS.length;
      blocks.push({ type: "h3", text: t.slice(4), key: idx, section });
    } else if (t.startsWith("## ") || t.startsWith("# ")) {
      flush();
      blocks.push({ type: "h2", text: t.replace(/^#+\s/, ""), key: idx, section });
    } else if (/^[-•] /.test(t)) {
      if (!list) list = { type: "ul", items: [], key: idx, section: Math.max(section, 0) };
      list.items.push(t.slice(2));
    } else if (/^\d+[.)] /.test(t)) {
      if (!list) list = { type: "ol", items: [], key: idx, section: Math.max(section, 0) };
      list.items.push(t.replace(/^\d+[.)] /, ""));
    } else if (/^-{3,}$/.test(t)) {
      flush();
    } else {
      flush();
      blocks.push({ type: "p", text: t, key: idx, section: Math.max(section, 0) });
    }
  });
  flush();

  return (
    <div className={`space-y-3 ${className}`}>
      {blocks.map((b) => {
        const c = SECTION_COLORS[b.section] || SECTION_COLORS[0];
        if (b.type === "h2") {
          return (
            <h3 key={b.key} className="font-display text-lg font-bold text-slate-900 tracking-tight pt-4 first:pt-0">
              {renderInline(b.text)}
            </h3>
          );
        }
        if (b.type === "h3") {
          return (
            <h4 key={b.key} className={`flex items-center gap-2 text-xs font-bold uppercase tracking-wider pt-3 ${c.heading}`}>
              <span className={`h-1.5 w-1.5 rounded-full ${c.dot} shrink-0`} />
              {renderInline(b.text)}
            </h4>
          );
        }
        if (b.type === "ul") {
          return (
            <ul key={b.key} className="space-y-1.5">
              {b.items.map((item, i) => (
                <li key={i} className="flex gap-2.5 text-sm text-slate-700 leading-relaxed">
                  <span className={`mt-[7px] h-1.5 w-1.5 rounded-full ${c.bullet} shrink-0`} />
                  <span>{renderInline(item)}</span>
                </li>
              ))}
            </ul>
          );
        }
        if (b.type === "ol") {
          return (
            <ol key={b.key} className="space-y-2">
              {b.items.map((item, i) => (
                <li key={i} className="flex gap-2.5 text-sm text-slate-700 leading-relaxed">
                  <span className={`h-5 w-5 rounded-md ${c.badge} text-[11px] font-bold flex items-center justify-center shrink-0 mt-0.5`}>
                    {i + 1}
                  </span>
                  <span>{renderInline(item)}</span>
                </li>
              ))}
            </ol>
          );
        }
        return <p key={b.key} className="text-sm text-slate-700 leading-relaxed">{renderInline(b.text)}</p>;
      })}
    </div>
  );
}
